import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Role } from 'src/app/backend-client/models/Backend/Core/Infrastructure/Aggregates/Identity/role';
import { MxMenuRightsPipe } from 'src/app/shared/pipes';

@Injectable({
  providedIn: 'root',
})
export class MxMenuService {
  private menuSource = new Subject<string>();
  private resetSource = new Subject<void>();

  menuSource$ = this.menuSource.asObservable();
  resetSource$ = this.resetSource.asObservable();

  menu: any[];

  constructor(private menuRightsPipe: MxMenuRightsPipe) {
    this.resetMenu();
  }

  resetMenu() {
    this.menu = [
      {
        label: 'Home',
        icon: 'fa fa-home fa-fw',
        routerLink: ['/'],
        visible: true,
      },
      {
        label: 'Tender',
        icon: 'fas fa-plus-circle fa-fw',
        visible: true,
        items: [
          {
            label: 'Products',
            icon: 'fas fa-tags fa-fw',
            routerLink: ['/products/tender'],
            visible: true,
          },
          {
            label: 'Posts',
            icon: 'fas fa-rss fa-fw',
            routerLink: ['/posts/tender'],
            visible: true,
          },
          // {
          //   label: 'Orders',
          //   icon: 'fas fa-cart-plus fa-fw',
          //   routerLink: ['/orders/tender'],
          //   visible: true,
          // },
        ],
      },
      {
        label: 'Custom_import',
        icon: 'fas fa-plus-circle fa-fw',
        visible: true,
        items: [
          {
            label: 'Custom_import_products',
            icon: 'fas fa-road fa-fw',
            routerLink: ['/products/custom-import'],
            visible: true,
          },
          {
            label: 'Contingent_licensed_products',
            icon: 'fas fa-rocket fa-fw',
            routerLink: ['/products/contingent-licensed'],
            visible: true,
          },
          {
            label: 'Posts',
            icon: 'fas fa-rss fa-fw',
            routerLink: ['/posts/custom-import'],
            visible: true,
          },
          {
            label: 'Orders',
            icon: 'fas fa-cart-plus fa-fw',
            routerLink: ['/orders/custom-import'],
            visible: true,
          },
        ],
      },
      {
        label: 'Registered_medicines',
        icon: 'fas fa-plus-circle fa-fw',
        visible: true,
        items: [
          {
            label: 'Products',
            icon: 'fas fa-boxes fa-fw',
            routerLink: ['/products/registered-medicines'],
            visible: true,
          },
          {
            label: 'Posts',
            icon: 'fas fa-rss fa-fw',
            routerLink: ['/posts/registered-medicines'],
            visible: true,
          },
          // {
          //   label: 'Orders',
          //   icon: 'fas fa-cart-plus fa-fw',
          //   routerLink: ['/orders/registered-medicines'],
          //   visible: true,
          // },
        ],
      },
      {
        label: 'Orders',
        icon: 'fas fa-cart-plus fa-fw',
        routerLink: ['/orders/all'],
        visible: true,
      },
      {
        label: 'Posts',
        icon: 'fas fa-rss fa-fw',
        routerLink: ['/posts/all'],
        visible: true,
      },
      {
        label: 'Administration',
        icon: 'fa fa-tools fa-fw',
        visible: this.menuRightsPipe.transform([
          Role.Admin,
          Role.Administrator,
        ]),
        items: [
          {
            label: 'Orders',
            icon: 'fas fa-cart-plus fa-fw',
            routerLink: ['/orders/admin-all'],
            visible: true,
          },
          {
            label: 'Products',
            icon: 'fas fa-boxes fa-fw',
            routerLink: ['/products/all'],
            visible: true,
          },
          {
            label: 'Category_posts',
            icon: 'fas fa-rss fa-fw',
            routerLink: ['/posts/category-posts'],
            visible: true,
          },
          {
            label: 'Product_posts',
            icon: 'fas fa-rss fa-fw',
            routerLink: ['/posts/product-posts'],
            visible: true,
          },
          {
            label: 'Product_documents',
            icon: 'fas fa-file fa-fw',
            routerLink: ['/documents/product'],
            visible: true,
          },
          {
            label: 'Subscriptions',
            icon: 'fa fa-bell fa-fw',
            routerLink: ['/subscriptions'],
            visible: true,
          },
          {
            label: 'Internal_users',
            icon: 'fa fa-user fa-fw',
            routerLink: ['/users/internal'],
            visible: true,
          },
          {
            label: 'External_users',
            icon: 'fa fa-user-md fa-fw',
            routerLink: ['/users/external'],
            visible: true,
          },
        ],
      },
    ];
  }

  onMenuStateChange(key: string) {
    this.menuSource.next(key);
  }

  reset() {
    this.resetSource.next();
  }
}
